import { Response } from './index';

export interface LinePay1ResData {
  info: {
    paymentAccessToken: string,
    paymentUrl: {
      app: string,
      web: string,
    }
    transactionId: string,
  }
  returnCode: string,
  returnMessage: string,
}

type LinePayFormData = {
  line_id?: string;
  mobile_number?: string;
  currency?: string;
  amount?: number;
};

// LINE Pay 綁定屬舊版金流功能,歸還與會員流程皆未使用,新後端亦不提供對應端點。
// 保留函式簽名讓既有 PaymentSetting 頁面照常編譯,但不再呼叫舊版 API(關閉舊版 API 目標);
// 回傳空資料時呼叫端會走既有的 failure 分支,不會 crash。
export const connectLine = async (
  _lineToken: string,
  _brandID: number,
  _formData: LinePayFormData,
): Promise<Response<LinePay1ResData>> => {
  return { data: undefined };
};

export interface LinePay2Expires {
  returnCode: string,
}

export const expiresLine = async (
  _lineToken: string,
  _brandID: number,
  _formData: LinePayFormData,
): Promise<Response<LinePay2Expires>> => {
  return { data: undefined };
};
